import { FunctionComponent, useEffect, useState } from 'react';
import './styles/TrialFooter.scss';

import { classNames, formatFullClassName, mapSelectedClassTrials } from '../utils';
import { Button, Select } from './core';
import { IDanceClass, IDanceSchool, IOptionsItem, ISelectedClassTrial, SCREEN_SIZE } from '../models';
import { TermsAndConditionsFooter } from './TermsAndConditionsFooter';

interface ITrialFooterProps {
  danceSchool: IDanceSchool;
  selectedClasses: IDanceClass[];
  screenSize: SCREEN_SIZE;
  disabled?: boolean;
  isError?: boolean;
  onSelectedTrialDatesChanged: (classTrials: ISelectedClassTrial[]) => void;
}
export const TrialFooter: FunctionComponent<ITrialFooterProps> = (props: ITrialFooterProps) => {

  const {
    danceSchool,
    selectedClasses,
    screenSize,
    disabled,
    isError,
    onSelectedTrialDatesChanged
  } = props;

  const [selectedClassTrials, setSelectedClassTrials] = useState<ISelectedClassTrial[]>([]);

  const handleTrialDateSelected = (classTrial: ISelectedClassTrial, selectedOption: IOptionsItem | null) => {
    const itemIndex = selectedClassTrials.indexOf(classTrial);
    const updatedItem: ISelectedClassTrial = {
      ...classTrial,
      selectedTrialDate: selectedOption?.value ?? ''
    };
    const classTrialsCopy = [...selectedClassTrials];
    classTrialsCopy.splice(itemIndex, 1, updatedItem);
    setSelectedClassTrials(classTrialsCopy);
  }

  useEffect(() => {
    setSelectedClassTrials(current => mapSelectedClassTrials(danceSchool, selectedClasses, current));
  }, [selectedClasses, danceSchool]);

  useEffect(() => {
    onSelectedTrialDatesChanged(selectedClassTrials);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClassTrials]);

  return (
    <div className={classNames('ppa-schedule-trial-footer', screenSize)}>
      {[SCREEN_SIZE.LARGE, SCREEN_SIZE.EXTRA_LARGE].includes(screenSize) && (
        <div className='footer-column'></div>
      )}

      <div className='footer-column'>
        {selectedClassTrials.length > 0 && (
          <div className='footer-selected-classes'>
            {selectedClassTrials.map((x, index) => (
              <div key={index} className='selected-class-row'>
                <div className='description'>
                  {formatFullClassName(x.classDetails)}
                </div>
                <div className='trial-time'>
                  <Select
                    label='Trial Date'
                    options={x.trialDateOptions}
                    onChange={(option) => handleTrialDateSelected(x, option)}
                    value={x.selectedTrialDate}
                    required
                    disabled={disabled}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
        
        {selectedClassTrials.length > 0 && (
          <TermsAndConditionsFooter danceSchool={danceSchool} />
        )}

        <div className='footer-actions'>          
          <Button
            type='submit'
            disabled={selectedClassTrials.length < 1}
            loading={disabled}
          >
            Trial {selectedClassTrials.length} class{selectedClassTrials.length !== 1 ? 'es' : ''}
          </Button>

          {isError && (
            <div className='error-label'>Something went wrong, please try again.</div>
          )}
        </div>
      </div>
    </div>
  )
}